import RestAPI from '../../components/Common/restApi';

import createCastleRequestToken from './Actions';

export async function postWithCastleRequestToken<PayloadObject>(
    requestUrl: string,
    formData: PayloadObject,
) {
    const castleToken = await createCastleRequestToken();

    const header = {
        'X-Castle-Request-Token': castleToken,
    };

    return RestAPI.postWithCustomHeaders(requestUrl, header, formData);
}

export async function putWithCastleRequestToken<PayloadObject>(
    requestUrl: string,
    formData: PayloadObject,
) {
    const castleToken = await createCastleRequestToken();

    const header = {
        'X-Castle-Request-Token': castleToken,
    };

    return RestAPI.putWithCustomHeaders(requestUrl, header, formData);
}